import { TextField, TextFieldProps } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react';
import { Form } from '~/shared/form/form';

type TextTranslation = {
	lang: string;
	name: string | null;
};

type FieldTextTranslationsProps<T extends TextTranslation> = TextFieldProps & {
	languages: T['lang'][];
};

function FieldTextTranslationsComponent<T extends TextTranslation>({
	field,
	languages,
	...props
}: Form.FieldProps<T[] | undefined, FieldTextTranslationsProps<T>>) {
	return (
		<Fragment>
			{languages.map(lang => (
				<TextField
					key={lang}
					fullWidth
					error={!!field.hasError}
					label={`${field.label} (${lang})`}
					onChange={e => {
						const current = field.value?.find(translation => translation.lang === lang);
						const translation = current
							? { ...current, name: e.target.value || null }
							: ({
									lang,
									name: e.target.value || null,
								} as T);
						field.set([
							...(field.value ?? []).filter(translation => translation.lang !== lang),
							translation,
						]);
					}}
					value={field.value?.find(translation => translation.lang === lang)?.name ?? ''}
					helperText={field.helperText}
					{...props}
				/>
			))}
		</Fragment>
	);
}

export const FieldTextTranslations = observer(FieldTextTranslationsComponent);
